import React from 'react';
import { Container, ProgressBar } from 'react-bootstrap';

const Progress = (props) => {
    return (
        <Container>
            <ProgressBar className="mb-20" now={props.progress} label={`${props.progress}%`} />
        </Container>
    );
}

export default Progress;